module.exports = __webpack_public_path__ + "img/vista_iconos_pequeños.6544d167.svg";